import React from 'react';
import { Box, Typography, FormControl, InputLabel, Select, MenuItem, FormHelperText, SelectChangeEvent } from '@mui/material';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectFieldProps {
  label: string;
  labelSuffix?: string;
  name: string;
  value: string | string[];
  onChange: (event: any) => void;
  onBlur?: (event: any) => void;
  error?: boolean;
  helperText?: string | false | undefined;
  required?: boolean;
  inputPlaceholder?: string;
  multiple?: boolean;
  options: SelectOption[];
  disabled?: boolean;
  valueColor?: (value: string | string[]) => string;
}

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  labelSuffix = ":",
  name,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  required = false,
  inputPlaceholder,
  multiple = false,
  options,
  disabled,
  valueColor,
  ...props
}) => {
  return (
    <Box>
      <Typography 
        variant="body2" 
        sx={{ 
          mb: 1, 
          fontWeight: 500, 
          color: "#333",
          display: 'flex',
          alignItems: 'center',
          '&::after': {
            content: required ? '"\u00a0*"' : `"\u00a0${labelSuffix}"`,
            color: required ? 'error.main' : '#333',
            ml: 0.5,
            fontSize: '1rem'
          }
        }}
      >
        {label}
      </Typography>
      <FormControl fullWidth error={error}>
        <Select
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          required={required}
          multiple={multiple}
          displayEmpty
          disabled={disabled}
          variant="outlined"
          sx={valueColor ? { color: valueColor(value) } : undefined}
          {...props}
        >
              {/* <MenuItem value="" disabled>
            {inputPlaceholder || `กรุณาเลือก${label}`}
            </MenuItem> */}
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </Box>
  );
};

export default SelectField; 